import { useTheme } from "@chakra-ui/react"
import { useMapSettings } from "../../components/providers/MapSettingsProvider"

export const useTripsStyle = () => {
  const { mapStyleSetting } = useMapSettings()
  const theme = useTheme()
  if (mapStyleSetting === "dark") {
    return {
      color: theme.colors.salomie,
      opacity: 0.7,
    }
  }
  if (mapStyleSetting === "satellite") {
    return {
      color: theme.colors.orange,
      opacity: 0.7,
    }
  }
  return {
    color: theme.colors.gray,
    opacity: 0.4,
  }
}

export const useTripsColorObj = () => {
  const { mapStyleSetting } = useMapSettings()
  const theme = useTheme()
  if (mapStyleSetting === "dark") {
    return theme.colors.salomie
  }
  if (mapStyleSetting === "satellite") {
    return theme.colors.orange
  }
  return theme.colors.gray
}

export const useGapsStyle = () => {
  const { mapStyleSetting } = useMapSettings()
  const theme = useTheme()
  if (mapStyleSetting === "dark") {
    return theme.colors.salomie["500"]
  }
  if (mapStyleSetting === "satellite") {
    return theme.colors.orange["800"]
  }
  return theme.colors.gray["500"]
}
